import type { LiceReportCages } from '@/domain/liceReport';

export type LiceReportDataSource = 'raw' | 'reporting';

export function mapLiceReportCagesByDataSource<T extends LiceReportCages>(
    cages: T[],
    dataSource: LiceReportDataSource
): T[] {
    const useRaw = dataSource === 'raw';

    // Daily reports only — weekly reports bypass this mapper. femaleAvg on daily cages is raw,
    // so falling back to it in reporting mode would show the wrong value.
    return cages.map((cage) => ({
        ...cage,
        femaleAvg: useRaw ? cage.femaleRawAvg : cage.femaleReportingAvg,
        femaleTotal: useRaw ? cage.femaleRawTotal : cage.femaleReportingTotal,
        movingStageAvg: useRaw ? cage.movingStageRawAvg : cage.movingStageReportingAvg,
        movingStageTotal: useRaw ? cage.movingStageRawTotal : cage.movingStageReportingTotal,
        caligusElongatusAvg: useRaw
            ? cage.caligusElongatusRawAvg
            : cage.caligusElongatusReportingAvg,
        caligusElongatusTotal: useRaw
            ? cage.caligusElongatusRawTotal
            : cage.caligusElongatusReportingTotal,
    }));
}
